export const props = Object.freeze({
  alignSelf: {
    type: String,
    default: undefined,
    validator: (value) => ["auto", "start", "end", "center", "baseline", "stretch"].includes(value),
  },
  alignItems: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "stretch"].includes(value),
  },
  cols: {
    type: [String, Number],
    default: 1,
  },
  colsSm: {
    type: [String, Number],
    default: undefined,
  },
  colsMd: {
    type: [String, Number],
    default: undefined,
  },
  colsLg: {
    type: [String, Number],
    default: undefined,
  },
  flexDirection: {
    type: String,
    default: "column",
    validator: (value) => ["row", "row-reverse", "column", "column-reverse"].includes(value),
  },
  noStartGap: {
    type: Boolean,
    default: false,
  },
  noEndGap: {
    type: Boolean,
    default: false,
  },
  // Deprecated props
  lg: {
    type: [String, Number],
    default: undefined,
  },
  md: {
    type: [String, Number],
    default: undefined,
  },
  sm: {
    type: [String, Number],
    default: undefined,
  },

  offset: {
    type: [String, Number],
    default: undefined,
  },
  offsetLg: {
    type: [String, Number],
    default: undefined,
  },
  offsetMd: {
    type: [String, Number],
    default: undefined,
  },
  offsetSm: {
    type: [String, Number],
    default: undefined,
  },
});
